<template>
  <div>
    <v-layout class="top_brd_crumbs_wrap mt-20">
      <v-flex class="brd_crumbs">
        <v-btn
          text
          :class="active_tab == 'All' ? 'actv' : ''"
          @click="fnChangeTab('All')"
        >{{$t('common.common.all')}}
        </v-btn>
        <v-btn
          text
          :class="active_tab == 'Document' ? 'actv' : ''"
          @click="fnChangeTab('Document')"
        >{{$t('myapplication.myapplication_details.fields.document')}}
        </v-btn>
        <v-btn
          text
          :class="active_tab == 'Payment' ? 'actv' : ''"
          @click="fnChangeTab('Payment')"
        >{{$t('myapplication.myapplication_details.fields.payment')}}
        </v-btn>
        <v-btn
          text
          :class="active_tab == 'AnnualFee' ? 'actv' : ''"
          @click="fnChangeTab('AnnualFee')"
        >{{$t('myapplication.myapplication_details.fields.annual_fee')}}
        </v-btn>
      </v-flex>
    </v-layout>
    <!-- active_type에 따라 활성화 한다 -->

    <!-- All -->
    <div v-if="active_tab === 'All'">
      <UpcomingDocumentAll
        :seq.sync="seq"
        :application_no="application_no"
        @annualfee="fnShowAnnualFeeInvoice"
        @payment="fnShowPaymentInvoice"
      />
    </div>

    <!-- Document -->
    <div v-if="active_tab === 'Document'">
      <UpcomingDocument
        :seq.sync="seq"
        :application_no="application_no"
      />
      <!-- 나중에 due date를 사용하게 되면 해당 값도 같이 넘겨 주면 될듯 -->
    </div>

    <!-- Payment -->
    <div v-if="active_tab === 'Payment'">
      <UpcomingDocumentPayment
        :seq.sync="seq"
        @payment="fnShowPaymentInvoice"
      />
    </div>

    <!-- AnnualFee -->
    <div v-if="active_tab === 'AnnualFee'">
      <UpcomingDocumentAnnualFee
        :seq.sync="seq"
        @annualfee="fnShowAnnualFeeInvoice"
      />
    </div>

    <DialogInvoice
      :prop_dialog_invoice="dialog_invoice"
      :prop_invoiceList="invoiceList"
      :query="$route.query"
      :prop_selected.sync="selected"
      @close="fnCloseDialogInvoice"
      @error="fnSetDialog">
    </DialogInvoice>
  </div>
</template>

<script>
import UpcomingDocumentAll from './UpcomingDocumentAll'
import UpcomingDocument from './UpcomingDocument'
import UpcomingDocumentPayment from './UpcomingDocumentPayment'
import UpcomingDocumentAnnualFee from './UpcomingDocumentAnnualFee'
import DialogInvoice from '@/components/layout/DialogInvoice'
import requestApi from '@/utils/requestApi'
import eventBus from '@/utils/eventBus'
import utils from '@/utils/utils'

export default {
  name: 'Upcomings',
  props: {
    seq:  String,
    active_type: String,
    application_no: String
  },
  components:{
    UpcomingDocument,
    UpcomingDocumentAll,
    UpcomingDocumentPayment,
    UpcomingDocumentAnnualFee,
    DialogInvoice,
  },
  data () {
		return {
      active_tab: '',

      dialog_invoice: false,
      invoiceList: [],
      selected: [],

    }
  },
  mounted(){
    this.active_tab = this.active_type
  },
  methods : {
    fnChangeTab(active_tab){
      this.active_tab = active_tab
    },

    fnShowAnnualFeeInvoice(item) {
      if (!item.applicant_type_code) {
        let option = {
          text: this.$t('maintenance.payannualfee.fields.call_egpo')
        }
        eventBus.$emit('SHOW_SNACKBAR', option)
      } else {
        let params = ''
        if(item.annual_seq !== ''){
          params += '?seqs='+item.annual_seq
        }

        requestApi({
          url: '/application/annualfees/invoices'+ params,
          method: 'GET',
          callback: (res) => {
            if (res.res_code === '200') {
              for (let i = 0; i < res.data.list.length; i++) {
                res.data.list[i].no = i + 1
              }
              this.invoiceList = res.data.list
              this.dialog_invoice = true
            }else {
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnShowAnnualFeeInvoice(item)
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              }
            }
          }
        })
      }
    },

    fnShowPaymentInvoice(item) {
      requestApi({
        url: '/application/'+ item.application_seq +'/payment/invoices',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = i + 1
            }
            this.invoiceList = res.data.list
            this.dialog_invoice = true
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnShowPaymentInvoice(item)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnCloseDialogInvoice() {
      this.dialog_invoice = false
    },
   fnSetDialog(option) {
      this.$router.push(option.path)
      eventBus.$emit('SHOW_DIALOG', option)
    }

  }
}
</script>